import React from 'react';
import GEO from '../classes/geo/geoLocation';
import {HAS, HAS_NO, HAS_YES, IS, IS_NO, IS_YES, NOT_FOUND, UNSPECIFIED} from '../consts';

/**
 * Склонение числительных
 * @param num integer количество
 * @param textForms array варианты склонений [для одного, для двух-четырёх, больше четырёх]
 * @return string
 */
export function num2str (num, textForms) {
  const n = Math.abs(num) % 100;
  const n1 = n % 10;

  if (n > 10 && n < 20) {
    return textForms[2];
  }

  if (n1 > 1 && n1 < 5) {
    return textForms[1];
  }

  if (n1 === 1) {
    return textForms[0];
  }

  return textForms[2];
}

export function textToParagraphs (text) {
  const lines = text.trim().split('\n') || [];

  const paragraphs = lines.map((line, key) => React.createElement('p', {key}, line));

  return paragraphs.length ? paragraphs : null;
}

export function breakLine (text) {
  const br = React.createElement('br');
  const regex = /(<br \/>)/g;

  return text.split(regex).map(function (line, index) {
    return line.match(regex) ? <br key={'key_' + index} /> : line;
  });
}

export function fixed (number, fractional = 2) {
  number = isNaN(parseFloat(number)) ? 0 : parseFloat(number).toFixed(fractional);

  return number.replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1\u00A0');
}

export function fixedPrice (value, per = null, devider = '/') {
  const suffix = per ? (devider + per) : '';
  const price = fixed(value);

  return price.replace('.00', '') + '\u00A0₽' + suffix;
}

export function firstLetter (word) {
  return word.charAt(0).toUpperCase();
}

export function capitalizeFirstLetter (string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function percentage (partialValue, totalValue) {
  return ((100 * partialValue) / totalValue).toFixed(2);
}

export function joinWithSeparator (data, sep = '/') {
  const filtered = data.filter(v => v);
  return filtered.join(sep);
}

export function truncToLower (input, cap) {
  const limit = Number(cap);
  const result = input.substr(0, limit);
  return result.toLowerCase();
}

/**
 * Преобразует булевое значение в строку
 * @param value
 * @param type
 * @returns {string}
 */
export function boolToString (value, type) {
  if (value === null) {
    return UNSPECIFIED;
  }

  switch (type) {
    case HAS:
      return value ? HAS_YES : HAS_NO;
    case IS:
      return value ? IS_YES : IS_NO;
  }

  return NOT_FOUND;
}

export function truncText (input, cap, delimiter = '…') {
  const limit = Number(cap);
  if (isNaN((limit))) {
    return delimiter;
  }
  if (input.length <= limit) {
    return input;
  }
  const result = input.substr(0, limit);
  const i = result.lastIndexOf(' ');
  if (i === -1) {
    return delimiter;
  }

  return result.substr(0, i) + ' ' + delimiter;
}

const localityDistrictsCache = {};
export function normalizeLocalityDistricts (domain) {
  const regionId = domain.get('regionId');
  const districs = domain.get('localityDistricts');
  const regionDistrics = domain.get('regionDistricts', []);
  const territory = domain.get('territory');

  if (localityDistrictsCache[regionId]) {
    return localityDistrictsCache[regionId];
  }

  const items = districs.map(item => {
    return {
      id: item.get('id'),
      name: territory.get('l_' + item.get('id')),
      shortName: territory.get('l_' + item.get('id'))
    };
  }).toJS();

  if (regionId === GEO.REGION_OMSK || regionDistrics.size) {
    items.push({
      id: 'suburb',
      name: 'Область',
      shortName: 'Область'
    });
  }

  localityDistrictsCache[regionId] = items;

  return items;
}



// WEBPACK FOOTER //
// ./src/utils/formater.js